import { render, staticRenderFns } from "./Maramures.vue?vue&type=template&id=0a0ad810&"
import script from "./Maramures.vue?vue&type=script&lang=js&"
export * from "./Maramures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports